export default {"src":"/_next/static/media/flutter.49095fa4.svg","height":299,"width":256,"blurWidth":0,"blurHeight":0};